module.exports = __webpack_public_path__ + "assets/svg/UI/location-white-0d16d9.svg";